var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-number-single"},[_c('count-to',{staticClass:"count",attrs:{"startVal":0,"endVal":_vm.number,"duration":2000,"decimals":2}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }